import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const debug = false && window.location.hostname === 'localhost'

const files = require.context('./modules', false, /\.module\.js/)
const fileEntries = files.keys()
  .map(key => [key.replace(/(\.\/|\.module\.js)/g, ''), files(key).default])
const modules = Object.fromEntries(fileEntries)

export default new Vuex.Store({
  state: {
    showYST: !!['preview'].includes(process.env.NODE_ENV) // 显示亿数通相关
  },
  modules,
  getters: {
    // entry
    serviceId: (state) => state.entry.serviceId,
    systemCode: (state) => state.entry.systemCode,
    menus: (state) => state.entry.menus,
    subMenus: (state) => state.entry.subMenus,
    visibleMenus: (state) => state.entry.menus.filter(item => item.tabVisible),
    customMenus: (state) => state.entry.customMenus,
    menusActiveID: (state) => state.entry.menusActiveID,
    panes: (state) => state.entry.panes,
    iframes: (state) => state.entry.iframes,
    panesHistory: (state) => state.entry.panesHistory,
    activeKey: (state) => state.entry.activeKey,
    favorites: (state) => state.entry.favorites,
    paidPageFlag: (state) => state.entry.paidPageFlag,
    activePane: (state) => state.entry.activePane,
    // permission
    microApps: (state) => state.permission.microApps,
    systems: (state) => state.permission.systems,
    currentSystem: (state) => state.permission.systems.find(item => item.systemCode === state.entry.systemCode),
    // user
    userInfo: (state) => state.user.info,
    systemCodes: (state) => state.user.systemCodes,
    userConfig: (state) => state.user.config,
    notification: (state) => state.user.notification,
    messageClassification: (state) => state.user.messageClassification,
    guidePageProcess: (state) => state.user.guidePageProcess,
    // app
    currentLang: (state) => state.app.lang,
    localDefaultConfig: (state) => state.app.localDefaultConfig,
    isDemo: (state) => state.app.isDemo,
    broadcastMessage: (state) => state.broadcast.message
  },
  plugins: debug ? [createLogger()] : [] // 开发环境下显示vuex的状态修改
})
